/**
 * @author Carlos Fernando Herrera Guillen
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
    'TablaImpresion.Acciones': 'Acciones ',
    'TablaImpresion.Margenes': 'Márgenes',
    'TablaImpresion.NombreEtiqueta': 'Nombre etiqueta',
    'TablaImpresion.PapelTamano': 'Papel tamaño',
    'TablaImpresion.Pallet': 'Es Pallet',
    'TablaImpresion.CodigoInterno': 'Código Interno',
    'TablaImpresion.CodigoEmpresaItem': 'Código Empresa',
    'TablaImpresion.Producto': 'Producto',
    'TablaImpresion.Unidad': 'Unidad',
    'TablaImpresion.Lote': 'Lote',
    'TablaImpresion.Serial': 'Serial',
    'TablaImpresion.Filtros': 'Filtros',
    'TablaImpresion.Etiqueta': 'Etiqueta ',
    'TablaImpresion.SerialInicio': 'Serial inicio',
    'TablaImpresion.SerialFin': 'Serial fin ',
    'TablaImpresion.Impresora': 'Impresora',
    'TablaImpresion.NumeroCopias': 'Numero copias',
    'TablaImpresion.EsPallet': ' Es pallet',
    'boton.Imprimir': 'Imprimir',
    'boton.Buscar': 'Buscar',
    'boton.Limpiar': 'Limpiar',
    'TablaImpresion.DescripcionEtiqueta': 'Descripción etiqueta',
    'TablaImpresion.Tamano': 'Tamaño',
    'TablaImpresion.Clasificacion': 'Clasificación',
    'TablaImpresion.Imprimir': 'Imprimir',
    'TablaImpresion.FechaIngreso': 'Fecha ingreso',
    'TablaImpresion.FechaVencimiento': 'Fecha vencimiento',
    'boton.AbrirFoemularioItemEtiqueta':'Administrar item',
    'TablaImpresion.CantidadPallet':'Cantidad pallet',
    'TablaImpresion.ConfirmacionImpresion':'Esta seguro que desea imprimir los productos seleccionados',
    'sidebar.impresion':'Impresión',
    'TablaEtiquetaItems.ConfirmacionProductoEtiqueta':'Esta seguro que desea asociar los productos seleccionados a la etiqueta',
    'TablaEtiquetaItems.RequeridosProductoEtiqueta':'Debe seleccionar productos para asociar a la etiqueta',
    'TablaImpresion.SeleccioneEtiqueta':'Por favor seleccione una etiqueta',
    'TablaImpresion.CodigoDocumento':'Codigo documento',
    'TablaImpresion.Peso':'Peso'
    };

